<template>
  <div class="box">
    <dv-scroll-board
      :config="config"
      class="table"
      @click="handleRowClick"
    :style="{height:(brandList.length===1 ? '100%':'95%')}"/>
  </div>
</template>

<script>
import Api from '@/api'
import { dateFormat } from '@/utils/tools'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      Timer: null,
      config: {},
      data: [],
      updateTime: [dateFormat(new Date().setDate(new Date().getDate() - 2), 'yyyy-MM-dd'),
        dateFormat(new Date(), 'yyyy-MM-dd')],
      rawData: []
    }
  },
  created() {
    // 2分钟刷新一次数据
    this.initData()
    this.Timer = setInterval(() => {
      this.initData()
    }, 120000)
  },
  watch: {
    selfAreaId(v, o) {
      this.initData()
    },
    abnormalType(v) {
      this.initData()
    }
  },
  props: {
    abnormalType: {
      default: null,
      type: [String, Number]
    },
    selfAreaId: {
      default: '',
      type: String
    },
    brandList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters(['userBikeType'])
  },
  methods: {
    initData() {
      if (!this.selfAreaId) {
        this.config = {
          data: []
        }
        return
      }
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId,
        currentPage: 1,
        pageSize: 1000
      }
      if (vm.abnormalType === 1 || vm.abnormalType === 7 || vm.abnormalType === 13 || vm.abnormalType === 14) {
        params.abnormalType = vm.abnormalType
      } else {
        params.abnormalTypes = '1, 7, 13, 14'
      }
      if (vm.updateTime && vm.updateTime[0] && vm.updateTime[1]) {
        params.startTime = new Date(vm.updateTime[0]).getTime()
        params.endTime = new Date(vm.updateTime[1]).getTime() + (23 * 60 * 60 + 59 * 60 + 59) * 1000
      }
      if (this.userBikeType !== 2) {
        params.bikeType = this.userBikeType
      }
      Api.getMsg(params).then((res) => {
        if (res.code === 200) {
          const arr = res.data.lists.slice(0, 10)
          // 原始对象数组
          const rawList = arr
          // 新增 data 字段 rawData: []
          this.rawData = rawList
          vm.data = rawList.map((val, idx) => {
            return [
              val.brandName,
              this.getShowText(val),
              `<span style="color:#00DADA;">${this.getAbnormalType(
                val.abnormalType
              )}</span>`,
              // eslint-disable-next-line quotes
              dateFormat(val.updateTime, "yyyy-MM-dd hh:mm"),
              `<span class="detail-btn" data-idx="${idx}" style="color:#00DADA;cursor:pointer;">详情</span>`
            ]
          })
          vm.config = {
            data: vm.data
          }
        } else {
          console.log('获取异常告警数据为空')
        }
      })
    },
    getAbnormalType(type) {
      return {
        1: '站外还车',
        2: '违法设备',
        3: '超时未还',
        4: '异常站点',
        5: '故障车辆',
        6: '满桩还车',
        7: '非法车辆',
        8: '不可投放站点上架',
        9: '还车异常',
        10: '租车异常',
        11: '上架异常',
        12: '下架异常',
        13: '站外投车',
        14: '超区停放'
      }[String(type)]
    },
    getShowText(item) {
      let str = ''
      if (item.siteName) {
        str = item.siteName
      } else if (item.lon && item.lat) {
        str = `经度：${item.lon}，纬度：${item.lat}`
      } else {
        str = '骑行中'
      }
      return str
    },
    handleRowClick({ row, ceil }) {
      // ceil 为列索引(只有点了详情列才处理)
      if (typeof ceil !== 'string' || ceil.indexOf('detail-btn') === -1) return
      // 从 HTML 里取出 data-idx
      const match = ceil.match(/data-idx="(\d+)"/)
      if (!match) return
      const idx = Number(match[1])

      const item = this.rawData[idx]
      if (!item) return

      if (!item.lon || !item.lat) {
        this.$message && this.$message.warning('该条数据没有经纬度信息')
        return
      }
      // 抛给父组件 index.vue
      this.$emit('warnShowDetail', { ...item })
    }
  },
  beforeDestroy() {
    if (this.Timer) {
      clearInterval(this.Timer)
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  padding: 0 16px;
  .table {
    flex: 1;
    width: 100%;
  }
}
/deep/.row-item {
  background: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  background-color: transparent !important;
}
::v-deep .ceil:nth-child(1) {
  width: 5rem!important;
}
::v-deep.ceil:nth-child(2) {
  width: 7.5rem!important;
}
::v-deep .ceil:nth-child(3) {
  width: 5rem!important;
}
::v-deep .ceil:nth-child(4) {
  width: 9.375rem!important;
}
</style>
